import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuHeadingOption} from '@Components/contextual-menu/components/contextual-menu-heading-option';
import {ItemInteractivityLinkOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-interactivity-link-option';
import {InformationLinkOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/information-link-option';

export function ItemInteractivitySection(): ReactElement {
  return (
    <>
      <ContextualMenuHeadingOption id="text-interactivity-option" text={window.i18next.t('pmwjs_interactivity')} />
      <ItemInteractivityLinkOption />
      <InformationLinkOption />
    </>
  );
}
